import type { FormikErrors } from 'formik';
import type { AppTranslations } from 'translations/translations';
import type { FormSettingsValues } from '../GraphProtocolsSettings';

const THICKNESS_MIN = 1;

export const validateProtocolSettings =
  (msg: AppTranslations, edgeIsGroup: boolean) =>
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: reasonable for validation
  (values: FormSettingsValues): FormikErrors<FormSettingsValues> => {
    const errors: FormikErrors<FormSettingsValues> = {};
    const validationMessages =
      msg.canvasGraph.graphSidePanel.layoutSettings.protocolSettingsWindow.form
        .validation;
    if (edgeIsGroup && !values.label) {
      errors.label = validationMessages.required;
    }
    if (edgeIsGroup && !values.name) {
      errors.name = validationMessages.required;
    }
    if (values.lineThicknessThin < THICKNESS_MIN) {
      errors.lineThicknessThin = validationMessages.minValue.replace(
        '{limit}',
        (THICKNESS_MIN - 1).toString(),
      );
    }

    if (values.lineThicknessMedium < THICKNESS_MIN + 1) {
      errors.lineThicknessMedium = validationMessages.minValue.replace(
        '{limit}',
        THICKNESS_MIN.toString(),
      );
    }
    if (values.lineThicknessThick < THICKNESS_MIN + 2) {
      errors.lineThicknessThick = validationMessages.minValue.replace(
        '{limit}',
        (THICKNESS_MIN + 1).toString(),
      );
    }

    if (values.lineThicknessThin >= values.lineThicknessMedium) {
      errors.lineThicknessThin = validationMessages.nextValueLower;
    }

    if (values.lineThicknessMedium >= values.lineThicknessThick) {
      errors.lineThicknessMedium = validationMessages.nextValueLower;
    }

    return errors;
  };
